import statesOptions from '../data/states.json';
import validations from '../data/validations.json';

BrokerInformationController.$inject = [
  'ApplicationService',
  '$scope',
  '$location',
  '$window'
];

function BrokerInformationController (ApplicationService, $scope, $location, $window) {
  function init () {
    var formData = ApplicationService.getData();
    $scope.brokerInformation = formData.brokerInformation;
    $scope.today = new Date();
    $scope.futureDate = new Date().setFullYear($scope.today.getFullYear() + 20);
    $scope.validations = validations;
    $scope.statesOptions = statesOptions;
    $scope.submitForm = submitForm;
    $scope.previousStep = previousStep;
    $scope.previouslyAppointed = formData.previouslyAppointed;

    var eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
    eighteenYearsAgo.setHours(0, 0, 0, 0);
    $scope.eighteenYearsAgo = eighteenYearsAgo;

    var hundredYearsAgo = new Date();
    hundredYearsAgo.setFullYear(hundredYearsAgo.getFullYear() - 100);
    hundredYearsAgo.setHours(0, 0, 0, 0);
    $scope.hundredYearsAgo = hundredYearsAgo;

    $scope.$watch('brokerInformation.state', updateLicenses);
  }

  $scope.editAddress = function () {
    $scope.addressErrorDetails = null;
    $window.scrollTo(0, 0);
  };

  $scope.selectAddress = function (address) {
    var brokerInformation = ApplicationService.getData().brokerInformation;
    brokerInformation.streetAddress = address.address;
    brokerInformation.streetAddress2 = address.address2;
    brokerInformation.city = address.city;
    brokerInformation.state = address.state;
    brokerInformation.zipCode = address.zipCode;
    $scope.brokerInformation = brokerInformation;
    ApplicationService.setData({
      brokerInformation: brokerInformation
    });
    nextStep();
  };

  function updateLicenses () {
    var existingLicenses = $scope.brokerInformation.brokerLicenses;
    var residencyState = $scope.brokerInformation.state;
    $scope.brokerInformation.brokerLicenses = ApplicationService.generateLicenses(existingLicenses, residencyState, false);
  }

  function previousStep () {
    $location.path('/application/get-started');
  }

  function submitForm (form) {
    $window.scrollTo(0, 0);
    if (form.$valid) {
      nextStep();
    }
  }

  function nextStep () {
    $scope.addressErrorDetails = null;

    var data = {
      brokerInformation: $scope.brokerInformation
    };
    data.brokerInformation.streetAddress2 = (data.brokerInformation.streetAddress2 || '');

    ApplicationService.setData(data);
    $scope.loading = true;
    ApplicationService.validateAddress({
      address: data.brokerInformation.streetAddress,
      address2: data.brokerInformation.streetAddress2,
      city: data.brokerInformation.city,
      state: data.brokerInformation.state,
      zipCode: data.brokerInformation.zipCode
    }).then(function () {
      nextPage();
    }, function (response) {
      $scope.loading = false;
      $scope.addressErrorDetails = response;
    });
  }

  function nextPage () {
    $location.path('/application/agency-information');
  }

  init();
}

export default BrokerInformationController;



//////////////////
// WEBPACK FOOTER
// ./src/js/controllers/BrokerInformationController.js
// module id = 20
// module chunks = 0